import { MenuItem } from "shared/components/Spor";
import styled from "styled-components";

export const HorizontalContainer = styled.form`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin: 0 1rem;

  & > * + * {
    margin-left: 1rem;
  }
`;

// Name/phone number must never wrap - the header has a fixed height, so wrapped text would
// overflow it and overlap neighbouring elements.
export const ProfileDetails = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin-right: 1rem;
  white-space: nowrap;
`;

export const StatusMenuItem = styled(MenuItem)`
  justify-content: flex-start;
  text-align: left;
`;
